import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'

export const useRegistrationStore = defineStore('registration', () => {

    const configStore   = useConfigStore()
    const requestStore  = useRequestsStore()

    const registrateUserProcess = ref(false)
    const registrateUserMsg = ref({})
    const registrateUserCaptcha = ref({})
    const registrateUserCaptchaMsg = ref({})

    const registrateVerifyProcess = ref(false)
    const registrateVerifyMsg = ref({})

    async function registrateUser(payload) {

        registrateUserProcess.value = true

        if(payload) {

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/registration`, 
                method: 'POST', 
                data: payload
            })

            if(!request.error) {
                registrateUserMsg.value = { success: true, text: 'REGISTRATION_SUCCESS' }
            } else {
                registrateUserMsg.value = { success: false, text: request.error }
            }

        } else {
            registrateUserMsg.value = { success: false, text: 'REGISTRATION_ERROR_FIELDS' }
        }

        registrateUserProcess.value = false
    }

    async function registrateVerify(payload) {

        registrateVerifyProcess.value = true

        if(payload) {

            const request = await requestStore.fetchRequest({
                address: `${configStore.httpServer}/registration/verify/${payload}`, 
                method: 'GET'
            })

            if(!request.error) {
                registrateVerifyMsg.value = { success: true, text: 'REGISTRATION_VERIFIED' }
            } else {
                registrateVerifyMsg.value = { success: false, text: request.error }
            }
        }

        registrateVerifyProcess.value = false
    }

    const setRegistrateUserMsg = data => registrateUserMsg.value = data
    const setRegistrateVerifyMsg = data => registrateVerifyMsg.value = data

    return {

        registrateUserProcess,
        registrateUserMsg,
        registrateUserCaptcha, 
        registrateUserCaptchaMsg, 
        registrateVerifyProcess, 
        registrateVerifyMsg, 
        registrateUser, 
        registrateVerify, 
        setRegistrateVerifyMsg, 
        setRegistrateUserMsg
    }
})